import { DBDef_FHIRResourceParamValue } from '@app/fhir-shared';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
export const dispatch_onFHIRResourceParamValuesUpdated = new ThunderDispatcherV3('__onFHIRResourceParamValuesUpdated');
export class ModuleFE_FHIRResourceParamValue_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_FHIRResourceParamValue, dispatch_onFHIRResourceParamValuesUpdated);
        this._v1 = {};
    }
}
export const ModuleFE_FHIRResourceParamValue = new ModuleFE_FHIRResourceParamValue_Class();
//# sourceMappingURL=ModuleFE_FHIRResourceParamValue.js.map